import "../Location.css";

const guarantees = [
  {
    id: 1,
    title: "Verified Professionals",
    image: "/img/location/iso-verified.avif",
  },
  {
    id: 2,
    title: "Work Assurance",
    image: "/img/location/work_assurity.avif",
  },
  {
    id: 3,
    title: "On-Time Support",
    image: "/img/location/customer-support.avif",
  },
  {
    id: 4,
    title: "Covid-19 Safety",
    image: "/img/location/virus.avif",
  },
];

const GuaranteeCard = ({ item }) => (
  <div className="guarantee-card">
    <div className="guarantee-icon">
      <img src={item.image} alt={item.title} loading="lazy" />
    </div>

    <h3>{item.title}</h3>
  </div>
);

export default function HappinessGuarantee() {
  return (
    <section className="guarantee-section">
      <div className="guarantee-container">

        <h2 className="guarantee-title">
          Happiness Guarantee
        </h2>

        <div className="guarantee-grid">
          {guarantees.map((item) => (
            <GuaranteeCard key={item.id} item={item} />
          ))}
        </div>

      </div>
    </section>
  );
}